import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

type LicenceUnlockedDialogProps = {
    open: boolean;
    licenceEndDate: Date | string;
    onDismiss: () => void;
};

export const LicenceUnlockedDialog = ({ open, licenceEndDate, onDismiss }: LicenceUnlockedDialogProps): JSX.Element => {
    const expiry = dayjs(licenceEndDate).format("D MMMM YYYY");

    return (
        <Dialog open={open} onClose={onDismiss} fullWidth maxWidth="sm">
            <DialogTitle sx={{ pr: 6 }}>
                Congratulations
                <IconButton
                    aria-label="close"
                    onClick={onDismiss}
                    size="large"
                    sx={{ position: "absolute", right: 12, top: 12, color: "grey.500" }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography paragraph>
                    You have unlocked a full 6-month licence. All published collections are now available.
                </Typography>
                <Typography>Your licence runs until {expiry}.</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" size="large" onClick={onDismiss}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};
